module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "soil-texture-background.b23e3b42.jpeg";